export enum FileSizeUnit {
  Gb = 'Gb',
  Mb = 'Mb',
  Kb = 'Kb',
  B = 'b'
}

export type LimitedFileSizeUnit = FileSizeUnit.B | FileSizeUnit.Kb | FileSizeUnit.Mb;
